import { Component, ElementRef, ViewChild } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { AdminAction } from 'src/app/models/adminaction.model';
import { ComponentheaderService } from 'src/app/services/componentheader.service';
import { ModulemanagementService } from 'src/app/services/modules/modulemanagement.service';
import { SchoolmanagementService } from 'src/app/services/schoolmanagement.service';

@Component({
  selector: 'app-invitestudent',
  templateUrl: './invitestudent.component.html',
  styleUrls: ['./invitestudent.component.css']
})
export class InvitestudentComponent {
  @ViewChild('email') email!: ElementRef;
  moduleid: number = 0;
  schoolid: number | undefined;
  moduleinfo: any;
  loading: boolean = false;
  link: string =  window.location.origin + '/access/register?goto=';;
  showText = true;
  
  constructor(private toastr: ToastrService, private headerinfo: ComponentheaderService,
    private schoolmanager: SchoolmanagementService, private route: ActivatedRoute,
    public modulemanager: ModulemanagementService) { }

  async ngOnInit() {
    try {
      this.moduleid = this.route.snapshot.queryParams.moduleid;
      this.link += `/user/moduledetails?moduleID=${this.moduleid}`;
      
      this.headerinfo.setHeaderDisplay(
        `Invite Student`,
        [
          {
            displaytext: 'School',
            route: `/user/schoolhome`,
          },
          {
            displaytext: 'Course',
            route: `/user/moduledetails`,
            params: { moduleID: this.moduleid },
          },
          {
            displaytext: `Invite Students`,
            route: `/user/invitestudent`,
            params: this.route.snapshot.queryParams,
          },
        ],
        []
      );
      this.schoolid = await this.schoolmanager.getSchoolIdFromSubdomain().toPromise();
    }
    catch (e) {
      console.log('error:', e);
    }
  }

  async inviteStudent() {
    try {
      this.loading = true;
      if (!this.email.nativeElement.value) {
        this.toastr.error("Enter User Email");
        throw new Error("Enter User Email");
      }

      const emails = this.email.nativeElement.value
        .split(',')
        .map((x: string) => x.trim())
        .filter((x: string) => x);

      if (emails.length === 0) {
        this.toastr.error("Enter valid email(s)");
        throw new Error("Enter valid email(s)");
      }

      if (this.moduleid > 0) {
        let data = {
          moduleId: this.moduleid,
          emails: emails,
        };
        await this.modulemanager.sendStudentInvite(data).toPromise();
        var mailList = emails.join(', ');
        this.toastr.success(
          `${emails.length} invite${emails.length > 1 ? 's' : ''} sent to: ${mailList}`
        );
        this.email.nativeElement.value = '';
      }
    }
    catch (e: any) {
      this.toastr.error(e.message);
      console.log('error:', e);
    }
    finally{
      this.loading = false;
    }
  }

  async copyLink(): Promise<void> {
    try {
      await navigator.clipboard.writeText(this.link);
      this.toastr.info('Link copied!');
    } catch {
      this.toastr.error('Failed to copy link');
    }
  }
}
